import React, { useEffect, useState } from "react";
import { Redirect, Route, Switch } from "react-router";
import WithSpinner from "../../HOC/withSpinner/WithSpinner.component";
import WithMainContainer from "../../HOC/withMainContainer/WithMainContainer.HOC";
import WithMobileMenuContainer from "../../HOC/withMobileMenuContainer/withMobileMenuContainer.HOC";
import Messages from "../messages/messages.component";
import AlllReqs from "../alllReqs/alllReqs.component";
import Wallet from "../wallet/wallet.component";
import SingleReq from "../singleReq/singleReq.component";
import NewReq from "../newReq/newReq.component";
import FixedMenu from "../../containers/fixedMenu/fixedMenu.container";
import useMediaQuery from "../../hooks/useMediaQuery";
import Support from "../support/support.component";
import Jeton from "../jeton/jeton.component";
import UserInfoPage from "../userInfo/userInfoPage.component";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectUserToken } from "../../redux/user/user.selectors";
import { selectUserCookie } from "../../redux/login/login.selectors";
import socket from "../../assets/socketConnection";
import {
  fetchUserInfoAsync,
  setIsUserConnected,
} from "../../redux/user/user.actions";
import SocketConnectionStatus from "../../containers/SocketConnectionStatus/SocketConnectionStatus";
import VehicleCategory from "../../containerSmall/vehicleCategory/vehicleCategory.component";
const AllReqsWithMainContainer = WithMainContainer(AlllReqs);
const VehicleCategoryWithMainContainer = WithMainContainer(VehicleCategory);
const SingleReqWithMainContainer = WithMainContainer(SingleReq);
const WalletWithMainContainer = WithMainContainer(Wallet);
const NewReqWithMainContainer = WithMainContainer(NewReq);
const MessagesWithContainer = WithMainContainer(Messages);
const MenueWithContainer = WithMobileMenuContainer(FixedMenu);
const SupportWithMainContainer = WithMainContainer(Support);
const JetonWithMainContainer = WithMainContainer(Jeton);
const UserInfoPageWithMainContainer = WithMainContainer(UserInfoPage);
const SocketConnectionStatusWithMainContainer = WithMainContainer(
  SocketConnectionStatus
);

const CoreApp = ({
  selectUserToken,
  selectUserCookie,
  fetchUserInfoAsync,
  setIsUserValid,
  setIsUserConnected,
}) => {
  let size = useMediaQuery();
  if (document?.referrer?.includes("login")) {
    if (!size.includes("xm")) {
      window.location.href = `/app2/reqs`;
    }
  }
  useEffect(() => {
    socket.on("connect", (data) => {
      console.log("SOCKET CONNECTED");
      socket.emit("authenticate", { token: selectUserToken });

      setIsUserConnected(true);

      fetchUserInfoAsync(socket);
    });
    socket.on("authenticate_status", (data) => {
      console.log({ data });
      // alert('hi')
      setIsUserValid(data.status);
    });
    socket.on("disconnect", (data) => {
      console.log("SOCKET DISCONNECTED");
      setIsUserConnected(false);
      socket.connect();
    });

    socket.on("response_notif_request_load", (data) => {
      // alert("بار شما ثبت شد");
      console.log(data);
    });
  }, []);

  return (
    <>
      <Switch>
        <Route
          exact
          path="/app2/reqs"
          render={() => <AllReqsWithMainContainer />}
        />
        <Route
          exact
          path="/app2/reqs/:id"
          render={() => <SingleReqWithMainContainer />}
        />

        <Route
          exact
          path="/app2/wallet"
          render={() => <WalletWithMainContainer />}
        />

        <Route
          exact
          path="/app2/new-req"
          render={() => <NewReqWithMainContainer />}
        />

        <Route
          exact
          path="/app2/new-req/instant/:id?"
          render={() => <NewReqWithMainContainer />}
        />
        <Route
          exact
          path="/app2/messages"
          render={() => <MessagesWithContainer />}
        />
        <Route exact path="/app2/home" render={() => <MenueWithContainer />} />
        <Route
          exact
          path="/app2/support"
          render={() => <SupportWithMainContainer />}
        />
        <Route
          exact
          path="/app2/jeton"
          render={() => <JetonWithMainContainer />}
        />
        <Route
          exact
          path="/app2/vehicle-category"
          render={() => <VehicleCategoryWithMainContainer />}
        />
        <Route
          exact
          path="/app2/user-info"
          render={() => <UserInfoPageWithMainContainer />}
        />
        <Route path="*">
          <Redirect to="/app2/reqs" />
        </Route>
      </Switch>
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  selectUserToken: selectUserToken,
  selectUserCookie: selectUserCookie,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUserInfoAsync: (x) => dispatch(fetchUserInfoAsync(x)),
  setIsUserConnected: (x) => dispatch(setIsUserConnected(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CoreApp);
